import * as React from 'react'

const MobilityOptionsDefaultIcon = (props: { className?: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Billing activity' clipPath='url(#clip0)'>
          <path
            d='M17.3722 18.2306L15.0704 19.1722L11.8423 12.6504L11.529 12.0204L10.7711 12.0298L3.7951 12.12L3.73102 10.765H9.5128V8.65752H3.63556L3.43252 4.28136C4.30139 3.93672 4.90974 3.14952 4.90974 2.2332C4.91 0.9984 3.81039 0 2.45553 0C1.09803 0 0 0.9984 0 2.2332C0 3.0132 0.441689 3.70032 1.10778 4.09728L1.53075 13.2324L1.57584 14.2555L2.70208 14.2416L10.0439 14.1468L13.4355 20.993L13.911 21.9528L14.9626 21.5234L18.3202 20.1514L17.3722 18.2306Z'
            transform='translate(4.67969)'
          />
          <path
            d='M14.8621 8.30832L14.551 8.24136C13.8709 10.7722 11.3898 12.5398 8.52289 12.5398C5.09907 12.5398 2.31498 10.0066 2.31498 6.8916C2.31498 4.97328 3.3716 3.22536 5.10171 2.184L4.80848 0.35448L4.60543 0C1.76412 1.33896 0 3.9792 0 6.8916C0 11.1667 3.82358 14.647 8.52289 14.647C11.7579 14.647 14.629 13.007 16.0725 10.4902L14.8621 8.30832Z'
            transform='translate(0 9.35352)'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MobilityOptionsDefaultIcon



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/MobilityOptions.tsx